import { IconButton, Tooltip, Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../context/listContext";
import { toggleUserData } from "../../api/users.api";
import { useAuth } from "../../context/authContext";
import { AntSwitch } from "../../styles/index.sty";
import { CSVLink } from "react-csv";
import DownloadIcon from "@mui/icons-material/Download";
import PuffLoader from "react-spinners/PuffLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const Users = () => {
  const { config } = useAuth();
  const { usersList, fetchUsersList } = useLists();
  const [csvList, setCsvList] = useState([]);
  const [loading, setLoading] = useState(true);

  const data = useMemo(() => usersList, [usersList]);

  const headers = [
    { label: "S.No.", key: "s_no" },
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "Mobile No", key: "mobile_no" },
    { label: "Email", key: "email" },
  ];

  useEffect(() => {
    fetchUsersList();
  }, []);
  useEffect(() => {
    if (usersList.length > 0) {
      setLoading(false);
    }
  }, [usersList]);
  const columns = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "first_name",
      },
      {
        Header: "Last Name",
        accessor: "last_name",
      },
      {
        Header: "E-mail",
        accessor: "email",
      },
      {
        Header: "Mobile Number",
        accessor: "mobile_no",
      },
      {
        Header: "User Type",
        accessor: "user_type",
      },
    ],
    []
  );

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      ...columns,
      {
        id: "ACTIONS",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              {/* <Tooltip
              title="edit"
              onClick={() => {
                // console.log(row.id)
                navigate("/update-user", {
                  state: {
                    data: row.original,
                  },
                });
              }}
            >
              <IconButton>
                <EditOutlined
                  style={{ fontSize: "2rem", color: "#0a305e" }}
                />
              </IconButton>
            </Tooltip> */}
              <Tooltip
                title={`${row.original.is_active ? "active" : "in-active"}`}
                onClick={() =>
                  toggleUserData(
                    { user_id: row.original.user_id },
                    config,
                    fetchUsersList
                  )
                }
              >
                <IconButton>
                  {" "}
                  <AntSwitch
                    checked={row.original.is_active ? true : false}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ]);
  };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  useEffect(() => {
    const dataList = [];
    usersList.forEach((user, i) => {
      // dataList.push({...user, s_no: i+1})
      dataList.push({
        // ...user,
        s_no: i + 1,
        first_name: user.first_name,
        last_name: user.last_name,
        mobile_no: user.mobile_no,
        email: user.email,
      });
    });
    setCsvList(dataList);
    console.log("===> this is the datalist", dataList);
  }, [usersList]);

  return (
    <>
      {loading ? (
        <Box sx={style}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
          <div className="flex justify-between w-[95%] m-auto mt-[5rem]">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              setGlobalFilter={setGlobalFilter}
              globalFilter={state.globalFilter}
            />
            <div className="w-[50%] flex justify-end">
              <IconButton className="w-[4rem]">
                <CSVLink data={csvList} headers={headers} filename="users.csv">
                  <DownloadIcon />
                </CSVLink>
              </IconButton>
            </div>
            {/* <Button
        type="button"
        variant="contained"
        // onClick={handleOpen}
        onClick={() => navigate('/add-user')}
      >
        Add New
      </Button> */}
          </div>
          <table {...getTableProps()} className="w-[95%] m-auto mt-10">
            <thead>
              {
                // Loop over the header rows
                headerGroups.map((headerGroup) => (
                  // Apply the header row props
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => (
                        // Apply the header cell props
                        <th
                          {...column.getHeaderProps()}
                          className="border-4 p-3 bg-[#1976d2] text-white"
                        >
                          {
                            // Render the header
                            column.render("Header")
                          }
                        </th>
                      ))
                    }
                  </tr>
                ))
              }
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                rows.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()}>
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          return (
                            //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                            <td
                              {...cell.getCellProps()}
                              className={`p-5 border-1px bg-${
                                index % 2 === 0 ? "white" : "blue-300"
                              } cursor-pointer text-center`}
                              style={{
                                background: !row.original.is_active
                                  ? "#b3b3b3"
                                  : null,
                              }}
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell")
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
